import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import type { CommunicationType } from "./communication.types";

// Whether the active tenant already has an open message of this kind; used to
// disable a send button (for example "Requested") so no duplicate is filed.
export const pendingCommunicationQueryOptions = (type: CommunicationType) =>
	queryOptions({
		queryKey: ["communication", "pending", type],
		queryFn: () => api.get<{ pending: boolean }>(`/platform/communication/pending?type=${type}`),
	});
